var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

$.extend(MDB.Charts, {
    renderKendoGauge: function (widget, chart, data, metadata, container, kendoFunc) {
        var imageUrl = document.location.origin + '/Widget/GetImage?filename=',
            min = metadata.KendoConfig.scale.min,
            max = metadata.KendoConfig.scale.max,
            errorMessage = MDB.loadResourceString('GenericWidget_InvalidDataErrorMessage') + ' ',
            value = validateData();

        if (value) {
            setTimeout(drawGauge, 0);
        }

        function validateData() {
            if (data && data.length === 1) {
                var keys = Object.keys(data[0]);
                if (keys.length === 1) {
                    return validateValue(data[0][keys[0]]);
                }
            }

            errorMessage += MDB.loadResourceString('Gauge_InvalidDataStructure_ErrorMessage');
            showError(errorMessage);
            return null;
        }

        function validateValue(val) {
            if (!$.isNumeric(val)) {
                errorMessage += sprintf(MDB.loadResourceString('Gauge_InvalidDataType_ErrorMessageFormat'), val);
                showError(errorMessage);
                return null;
            }
            if (val < min || val > max) {
                errorMessage += sprintf(MDB.loadResourceString('Gauge_InvalidValue_ErrorMessageFormat'),
                    min, max, val);
                showError(errorMessage);
                return null;
            }

            return val;
        }

        function showError(message) {
            widget.find('.loading-box').hide();
            chart.show().find('.no-data-message').remove();
            $('<div />', { 'class': 'no-data-message info' })
                .text(message)
                .appendTo(chart);
        }

        function drawGauge() {
            MDB.Charts.emptyChartAndMakeVisible(widget, chart);
            chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget));

            var backgroundPath = metadata.BackgroundPath ?
                imageUrl + metadata.BackgroundPath :
                // Grab the selected background from the editor when it is not yet saved.
                $('.k-state-selected .widget-background').attr('src');
            if (backgroundPath) {
                chart.css({
                    'background-image': 'url("' + backgroundPath + '")',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center',
                    'background-size': 'contain'
                });
            }

            var kendoConfig = { pointer: { value: value } };
            $.extend(true, kendoConfig, metadata.KendoConfig);

            chart.append(container);
            kendoFunc.call(container, kendoConfig);
        }
    }
})